import {
  dbui_v1_Query_LookupRequest,
  dbuiV1QueryLookupMutation,
  dbuiV1QueryLookupOptions,
} from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { defaultOptions } from '@/utils/query';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';

export const useGetQueryLookup = (
  queryId: string | undefined | null,
  request: Omit<dbui_v1_Query_LookupRequest, 'warehouse'>,
  disabled?: boolean,
) => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  const warehouse = selectedWarehouse?.id;

  const { startValue, ...body } = request;

  return useQuery({
    ...dbuiV1QueryLookupOptions({
      ...defaultOptions(),
      path: { workspace: workspace ?? '', id: queryId! },
      body: {
        ...body,
        warehouse,
      },
    }),
    enabled: !!queryId && !disabled,
  });
};

export const useGetQueryLookupImperative = () => {
  return useMutation({
    ...dbuiV1QueryLookupMutation({
      ...defaultOptions(),
    }),
  });
};
